<template>
  <div class="index-page container">
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Изображение</h3>
      <n-image inline centered bg :src="image" />
      
      <n-form @submit="saveImage">
        <n-items>
          <n-upload title="Загрузить новое изображение" :value.sync="newImage" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-input title="Название" v-bind="$form.input('title')" />
          <n-input title="Полное название" v-bind="$form.input('fullTitle')" />
          <n-input title="Краткое описание" v-bind="$form.input('desc')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-input title="Направление" v-bind="$form.input('direction')" />
          <n-input title="Ссылка" v-bind="$form.input('url')" />
          <n-select title="Показывать на сайте" :data="actives" v-bind="$form.input('isActive', 'select')" />
          <n-input title="CloudPayments publicId" v-bind="$form.input('cloudPaymentsId')" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление партнера</h3>
      Осторожно! Удаление действие необратимо!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteModel">Удалить партнера</n-button>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    image: null,
    newImage: null,
    actives: [
      { id: 'true', title: 'Да', },
      { id: 'false', title: 'Нет', },
    ],
  }),
  computed: {
    modelId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    loadModel() {
      this.$var('load', true)
      $api.app.partners.get(this.modelId).then((response) => {
        const result = response.data.content
        this.image = result.image
        result.isActive = $n.find(this.actives, [ 'id', result.isActive+'', ])
        this.$form.init(result)
        this.$form.set('image', undefined)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const data = {
        ...this.$form.get(),
        isActive: this.$form.get('isActive')?.id === 'true',
      }
      $api.app.partners.edit(this.modelId, data).then((result) => {
        this.loadModel()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    saveImage() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newImage, }).then((file) => {
        $api.app.partners.edit(this.modelId, { image: file.data.content.id, }).then((result) => {
          this.image = result.data.content.image
          this.newImage = null
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
    deleteModel() {
      this.$var('loadDelete', true)
      $api.app.partners.delete(this.modelId).then((response) => {
        this.$router.push({ name: 'partners.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
    
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .avatar {
      border: 2px solid red;
    }
  }
</style>
